<template>
  <div class="main-div">
    <div class="bg-main-color1" style="
        padding: 10px;
        color: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
      ">
      <div style="flex: 1;">
        <strong>{{ label }}</strong>
        <span v-if="filterBreadcrumb" style="font-weight: normal; opacity: 0.9;">
        <v-icon small class="mr-1" style="vertical-align: middle; opacity: 0.8;">mdi-filter</v-icon>
        {{ filterBreadcrumb }}
</span>

      </div>
      
      <!-- Archive Toggle Button -->
      <button 
        class="archive-toggle-btn"
        @click="toggleShowArchived"
        :title="showArchived ? 'Hide archived surveys' : 'Show archived surveys'">
        <i :class="showArchived ? 'fa-solid fa-eye-slash' : 'fa-solid fa-archive'"></i>
        {{ showArchived ? 'Hide Archived' : 'Show Archived' }}
      </button>
      
      <button class="bg-main-color1" style="color: #fff; margin-left: 10px;" @click.prevent="toggle = !toggle" v-show="!toggle">
        Show
      </button>
      <button class="bg-main-color1" style="color: #fff; margin-left: 10px;" @click.prevent="toggle = !toggle" v-show="toggle">
        Hide
      </button>
    </div>
<div class="parent" v-show="toggle">

      <!-- ===== TEMP: 3 hardcoded "new design" demo tiles for client comparison — remove after approval ===== -->
      <!-- <div class="demo-tile">
        <div class="demo-archive"><i class="fa-solid fa-archive"></i></div>
        <div class="demo-eyebrow">Values Fit Profile</div>
        <div class="demo-badge demo-badge--vfp">VFP</div>
        <div class="demo-title">Values Fit Profile™ [ID 036]</div>
        <div class="demo-sub">VFP 18</div>
        <div class="demo-icons">
          <div class="demo-icon demo-icon--info"><i class="fa-solid fa-info"></i></div>
          <div class="demo-icon demo-icon--warning"><i class="fa-solid fa-triangle-exclamation"></i></div>
        </div>
        <button class="demo-btn demo-btn--primary">Display Submitted Survey</button>
      </div> -->

      <div class="demo-tile">
        <div class="demo-archive"><i class="fa-solid fa-archive"></i></div>
        <div class="demo-eyebrow">TalentSage 360°</div>
        <div class="demo-badge demo-badge--360">360</div>
        <div class="demo-title">TalentSage - General Manager 360° Survey</div>
        <div class="demo-sub">Sniff test for database check iteration - TS</div>
        <div class="demo-icons">
          <div class="demo-icon demo-icon--info">2</div>
          <div class="demo-icon demo-icon--warning">3</div>
        </div>
        <div class="demo-actions">
          <button class="demo-btn demo-btn--primary">Take Survey</button>
          <button class="demo-btn demo-btn--secondary">Nominate</button>
        </div>
      </div>

      <!-- <div class="demo-tile">
        <div class="demo-archive"><i class="fa-solid fa-archive"></i></div>
        <div class="demo-eyebrow">Board Effectiveness</div>
        <div class="demo-badge demo-badge--bep">BEP</div>
        <div class="demo-title">Board Effectiveness Profile™ [ID 107]</div>
        <div class="demo-sub">Test - BEP program - Nov 07 2023</div>
        <div class="demo-icons">
          <div class="demo-icon demo-icon--check"><i class="fa-solid fa-check"></i></div>
          <div class="demo-icon demo-icon--info"><i class="fa-solid fa-info"></i></div>
        </div>
        <button class="demo-btn demo-btn--primary">Display Submitted Survey</button>
      </div> -->
      <!-- ===== END TEMP demo tiles ===== -->

      <!-- Loading State -->
      <div v-if="isLoading" class="loading-container">
        <div class="spinner"></div>
        <p class="loading-text">Loading your surveys...</p>
      </div>

      <!-- No Survey Message -->
      <h3 v-else-if="noSurvey">No tasks assigned to you at this time</h3>

      <!-- Survey Tiles -->
      <div v-else v-for="data in paginatedFilteredSurveys" :key="data.survey_assignment_id" style="cursor: pointer" :class="[
          data.submitted_status == 1 || data.dropped_status == 1
            ? 'child-submitted'
            : data.is_nomination == 1
            ? 'child-nominee'
            : 'child',
          { 'archived-tile': data.archived_status }
        ]">
        
        <!-- TOP SECTION: Text and Logo -->
        <div class="tile-top-section">
          <!-- Archive Icon Button (Top Right) -->
          <button
            class="archive-icon-btn"
            :class="{ 
              'archived': data.archived_status
            }"
            @click="openArchiveConfirmation(data.survey_assignment_id, data.archived_status)"
            :disabled="showArchiveConfirm"
            :title="data.archived_status ? 'Click to unarchive' : 'Click to archive'">
            <i :class="data.archived_status ? 'fa-solid fa-box-open' : 'fa-solid fa-archive'"></i>
          </button>
          
          <div>
            <h3>{{ data.surveyName }}</h3>
            <h3>{{ data.iterationName }}</h3>
            <h3 v-if="data.subjectFullName != null">
              {{ "For: " + data.subjectFullName }}
            </h3>
            <div>
              <p>{{ data.programName }}</p>
            </div>
            <!-- logo images  -->
            <div v-if="data.survey_type == 1">
              <img class="surveyLogo" src="../../public/survey_logo/big5_survey_logo.png" />
            </div>
            <div v-if="data.survey_type == 6">
              <img class="surveyLogo baseline" src="../../public/survey_logo/baseline_logo.png" />
            </div>
            <div v-if="data.survey_type == 2">
              <img class="surveyLogo" src="../../public/survey_logo/360_survey_logo.png" />
            </div>
            <div v-if="data.survey_type == 3">
              <img class="surveyLogo" src="../../public/survey_logo/research_survey_logo.png" />
            </div>
            <div v-if="data.survey_type == 4 && data.survey_file == 'QSort-BEP.html'">
              <img class="surveyLogo" src="../../public/survey_logo/qSort_BEP.png" />
            </div>
            <div v-if="data.survey_type == 4 && data.survey_file == 'QSort-GDP.html'">
              <img class="surveyLogo" src="../../public/survey_logo/qSort_GDP.png" />
            </div>
            <div v-if="data.survey_type == 4 && data.survey_file == 'QSort-OCM.html'">
              <img class="surveyLogo" src="../../public/survey_logo/qSort_OCM.png" />
            </div>
            <div v-if="data.survey_type == 5">
              <img class="surveyLogo" src="../../public/survey_logo/VFP_logo.png" />
            </div>
            <!-- end of logo images  -->
          </div>
        </div>

        <!-- BOTTOM SECTION: Icons and Buttons -->
        <div class="tile-bottom-section">
          <!-- survey messages icons -->
          <div v-if="data.surveyMessages && data.surveyMessages.length > 0" class="message-icons-container">
            <div class="message-icons">
              <!-- Qualified Icon with Count -->
              <div 
                v-if="getMessageCount(data.surveyMessages, 'Qualified') > 0"
                class="message-icon"
                @click="openMessageModal(data.surveyMessages)"
                :title="'Click to view messages'">
                <i class="fa-solid fa-check icon-qualified"></i>
                <span v-if="getMessageCount(data.surveyMessages, 'Qualified') > 1" class="icon-badge badge-qualified">{{ getMessageCount(data.surveyMessages, 'Qualified') }}</span>
              </div>
              
              <!-- Info Icon with Count -->
              <div 
                v-if="getMessageCount(data.surveyMessages, 'Info') > 0"
                class="message-icon"
                @click="openMessageModal(data.surveyMessages)"
                :title="'Click to view messages'">
                <i class="fa-solid fa-info icon-info"></i>
                <span v-if="getMessageCount(data.surveyMessages, 'Info') > 1" class="icon-badge badge-info">{{ getMessageCount(data.surveyMessages, 'Info') }}</span>
              </div>
              
              <!-- Warning Icon with Count -->
              <div 
                v-if="getMessageCount(data.surveyMessages, 'Warning') > 0"
                class="message-icon"
                @click="openMessageModal(data.surveyMessages)"
                :title="'Click to view messages'">
                <i class="fa-solid fa-triangle-exclamation icon-warning"></i>
                <span v-if="getMessageCount(data.surveyMessages, 'Warning') > 1" class="icon-badge badge-warning">{{ getMessageCount(data.surveyMessages, 'Warning') }}</span>
              </div>
            </div>
          </div>
          <!-- end of survey messages icons -->

          <!-- self assessment  -->
          <div
            v-if="data.survey_type === '1' || data.survey_type === '6' || data.survey_type === '3' || data.survey_type === '4' || data.survey_type === '5'">
            <div v-if="
                data.is_nomination == 0 &&
                data.submitted_status == 0 &&
                data.dropped_status == 0
              ">
              <button :disabled="data.isShow == 'no'" :class="
                  data.isShow == 'no'
                    ? 'btn-disabled btn-take-survey'
                    : 'btn-nominee btn-take-survey'
                " @click="
                  takeSurvey(
                    data.survey_template_link,
                    data.survey_assignment_id,
                    data.ind_id,
                    data.org_id,
                    data.suborg_id,
                    data.subjectFullName,
                    data.survey_template_id,
                    data.iteration_id
                  )
                ">
                Take Survey
              </button>
            </div>
          </div>
          <!-- end of self assessment  -->

          <!-- 360 nomination -->
          <div v-else-if="data.survey_type == 2">
            <div class="d-flex">
              <button :disabled="data.isShow == 'no'" v-if="
                  data.is_nomination == 0 &&
                  data.submitted_status == 0 &&
                  data.dropped_status == 0
                " :class="
                  data.isShow == 'no'
                    ? 'btn-disabled px-25px'
                    : 'btn-nominee px-25px'
                " @click="
                  takeSurvey(
                    data.survey_template_link,
                    data.survey_assignment_id,
                    data.ind_id,
                    data.org_id,
                    data.suborg_id,
                    data.subjectFullName,
                    data.survey_template_id,
                    data.iteration_id
                  )
                ">
                Take Survey
              </button>

              <!-- Solo Make Nomination button (when submitted) -->
              <button :disabled="data.isShow == 'no'" 
                @click="
                  sendProps(
                    data.surveyName,
                    data.survey_assignment_id,
                    data.org_id,
                    data.suborg_id,
                    data.program_id,
                    data.iteration_id,
                    data.stream_id,
                    data.group_id,
                    data.survey_template_id,
                    data.survey_template_association_id,
                    data.ind_id,
                    data.recipient_email
                  )
                " 
                v-if="data.submitted_status == 1 && data.is_nomination == 0 && data.dropped_status == 0"
                :class="[
                  data.isShow == 'no' ? 'btn-disabled' : 'btn-nominee',
                  'solo-nomination',
                  'px-25px'
                ]"
                style="text-align: center;">
                Make Nomination
              </button>

              <!-- Make Nomination button when appearing with Take Survey -->
              <button :disabled="data.isShow == 'no'" 
                @click="
                  sendProps(
                    data.surveyName,
                    data.survey_assignment_id,
                    data.org_id,
                    data.suborg_id,
                    data.program_id,
                    data.iteration_id,
                    data.stream_id,
                    data.group_id,
                    data.survey_template_id,
                    data.survey_template_association_id,
                    data.ind_id,
                    data.recipient_email
                  )
                " 
                v-if="data.submitted_status == 0 && data.is_nomination == 0 && data.dropped_status == 0"
                :class="data.isShow == 'no' ? 'btn-disabled' : 'btn-nominee'">
                Make Nomination
              </button>
            </div>

            <!-- if the indivual is nominee and also participant and not yet submitted the survey -->
            <button :disabled="data.isShow == 'no'" v-show="
                data.is_nomination == 1 &&
                data.submitted_status == 0 &&
                data.dropped_status == 0
              " :class="
                data.isShow == 'no'
                  ? 'btn-disabled btn-take-survey-participant-nominee'
                  : 'btn-nominee btn-take-survey-participant-nominee'
              " @click="
                takeSurvey(
                  data.survey_template_link,
                  data.survey_assignment_id,
                  data.ind_id,
                  data.org_id,
                  data.suborg_id,
                  data.subjectFullName,
                  data.survey_template_id,
                  data.iteration_id
                )
              ">
              Take Survey
            </button>
          </div>
          <!-- end of 360 nomination -->

          <!-- dropped status  -->
          <div v-if="data.dropped_status === 1">
            <button v-if="data.dropped_status === 1" disabled
              class="btn-disabled btn-survey-completed-participant-nominee">
              Dropped
            </button>
          </div>
          <!-- end of dropped status  -->

          <!-- Display Submitted Survey -->
          <div v-if="data.submitted_status == 1">
            <button v-if="
              data.submitted_status == 1 &&
              data.dropped_status == 0
            " :class="data.submitted_status == 0
                    ? 'btn-disabled px-25px'
                    : 'btn-nominee px-25px'
                  " @click="
                  toggleDisplaySubmittedSurvey();
                  adminSurveyView(
                    data.survey_template_link,
                    data.survey_assignment_id,
                    data.ind_id,
                    data.org_id,
                    data.suborg_id,
                    data.subjectFullName,
                    data.survey_template_id,
                    data.iteration_id
                  )
                  ">
              Display Submitted Survey
            </button>
          </div>
          <div class="tooltip" v-if="userId" style="margin-top: 10px">
            Information
            <span class="tooltiptext">- Above this tooltip shows exactly what the participant see in
              their survey tile screen.
              <br />
              <br />- This tooltip and the button under this only shows for Admin
              to view the survey.</span>
          </div>
        </div>
        <!-- end of tile-bottom-section -->
      </div>
      <!-- for loop  -->

      <!-- Pagination -->
      <div v-if="!isLoading && !noSurvey && totalPages > 1" class="pagination-container">
        <button 
          class="pagination-btn" 
          :disabled="currentPage === 1"
          @click="goToPage(currentPage - 1)">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        
        <button 
          v-for="page in displayedPages" 
          :key="page"
          class="pagination-btn"
          :class="{ 'active': page === currentPage }"
          @click="goToPage(page)">
          {{ page }}
        </button>
        
        <button 
          class="pagination-btn" 
          :disabled="currentPage === totalPages"
          @click="goToPage(currentPage + 1)">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
        
        <div class="pagination-info">
          Page {{ currentPage }} of {{ totalPages }} 
          <span v-if="activeFilters">({{ filteredSurveys.length }} filtered / {{ surveyAssignments.length }} total)</span>
          <span v-else>({{ surveyAssignments.length }} total surveys)</span>
        </div>
      </div>
      <!-- End Pagination -->
    </div>
    <!-- parent  -->

    <!-- Message Modal -->
    <div v-if="showMessageModal" class="modal-overlay" @click="closeMessageModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Survey Messages</h3>
          <button class="modal-close" @click="closeMessageModal">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="modal-body">
          <div v-for="(item, index) in currentMessages" :key="index">
            <div v-if="item.survey_message_type && item.survey_message_type != ''" 
              class="modal-message-item"
              :style="{ backgroundColor: getStyle(item.survey_message_type) }">
              <div class="survey-message-container">
                <div class="message-icon-large">
                  <i v-if="item.survey_message_type == 'Qualified'" class="fa-solid fa-check"></i>
                  <i v-if="item.survey_message_type == 'Info'" class="fa-solid fa-info"></i>
                  <i v-if="item.survey_message_type == 'Warning'" class="fa-solid fa-triangle-exclamation"></i>
                </div>
                <div class="message-text">{{ item.survey_message }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Message Modal -->

    
  <ArchiveConfirmModal
      :visible="showArchiveConfirm"
      :is-loading="isArchivingModal"
      :is-success="archiveSuccess"
      :is-unarchive="!!confirmArchiveStatus"
      @confirm="confirmArchiveAction"
      @cancel="closeArchiveConfirmation"
      @done="closeArchiveConfirmation"
    />
  </div>
  <!-- main-div  -->
</template>

<script>
import api from "../api/api";
import { flashMessage } from "../functions.js";
import ArchiveConfirmModal from "./ArchiveConfirmModal.vue";

export default {
  name: "HomeSkillBuilding",
  components: { ArchiveConfirmModal },
  data: () => ({
    surveyId: "",
    toggle: true,
    surveyAssignments: [],
    noSurvey: false,
    isNominee: false,
    abortController: new AbortController(),
    isDisplaySubmittedSurvey: false,
    isLoading: true,
    showMessageModal: false,
    currentMessages: [],
    currentPage: 1,
    itemsPerPage: 10,
    showArchived: false, // NEW: Toggle for showing archived tiles
    isArchiving: {},
    showArchiveConfirm: false,
    confirmArchiveId: null,
    confirmArchiveStatus: false,
    isArchivingModal: false,
    archiveSuccess: false,
  }),
  props: {
    reportName: String,
    surveyName: String,
    dateTime: String,
    buttonLabel: String,
    label: String,
    buttonColor: String,
    userData: Object,
    brandData: Object,
    userId: Number,
    runMode: String,
    activeFilters: Object, // RECEIVE FILTERS FROM PARENT
  },
  computed: {
    filterBreadcrumb() {
      if (!this.activeFilters && !this.showArchived) {
        return '';
      }

      const parts = [];
      
      // Show archived status
      if (this.showArchived) {
        parts.push('📦 Archived');
      }
      
      // Organization
      if (this.activeFilters && this.activeFilters.organization) {
        parts.push(this.activeFilters.organization.name);
        
        // Sub-Organization
        if (this.activeFilters.subOrganization) {
          parts.push(this.activeFilters.subOrganization.name);
          
          // Program
          if (this.activeFilters.program) {
            parts.push(this.activeFilters.program.name);
            
            // Iteration
            if (this.activeFilters.iteration) {
              parts.push(this.activeFilters.iteration.name);
              
              // Stream
              if (this.activeFilters.stream) {
                parts.push(this.activeFilters.stream.name);
                
                // Group
                if (this.activeFilters.group) {
                  parts.push(this.activeFilters.group.name);
                } else {
                  const groupCount = this.activeFilters.stream.groups?.length || 0;
                  if (groupCount > 1) {
                    parts.push('many');
                  }
                }
              } else {
                const streamCount = this.activeFilters.iteration.streams?.length || 0;
                if (streamCount > 1) {
                  parts.push('many');
                }
              }
            } else {
              const iterationCount = this.activeFilters.program.iterations?.length || 0;
              if (iterationCount > 1) {
                parts.push('many');
              }
            }
          } else {
            const programCount = this.activeFilters.subOrganization.programs?.length || 0;
            if (programCount > 1) {
              parts.push('many');
            }
          }
        } else {
          const subOrgCount = this.activeFilters.organization.subOrgs?.length || 0;
          if (subOrgCount > 1) {
            parts.push('many');
          }
        }
      }
      
      return parts.join(' / ');
    },
    filteredSurveys() {
      let surveys = this.surveyAssignments
        .filter(s => s && s.survey_assignment_id && s.survey_template_name)
        .sort((a, b) => b.survey_assignment_id - a.survey_assignment_id);
      // FILTER OUT ARCHIVED (unless showArchived is true)
      if (!this.showArchived) {
        surveys = surveys.filter(survey => !survey.archived_status);
      }

      if (!this.activeFilters) {
        return surveys;
      }

      return surveys.filter(survey => {
        if (this.activeFilters.organization && 
            survey.org_id !== this.activeFilters.organization.id) {
          return false;
        }

        if (this.activeFilters.subOrganization && 
            survey.suborg_id !== this.activeFilters.subOrganization.id) {
          return false;
        }

        if (this.activeFilters.program && 
            survey.program_id !== this.activeFilters.program.id) {
          return false;
        }

        if (this.activeFilters.iteration && 
            survey.iteration_id !== this.activeFilters.iteration.id) {
          return false;
        }

        if (this.activeFilters.stream && 
            survey.stream_id !== this.activeFilters.stream.id) {
          return false;
        }

        if (this.activeFilters.group && 
            survey.group_id !== this.activeFilters.group.id) {
          return false;
        }

        if (this.activeFilters.searchQuery) {
          const query = this.activeFilters.searchQuery.toLowerCase();
          const fullName = survey.subject_full_name?.toLowerCase() || '';
          const programName = survey.program_name?.toLowerCase() || '';
          const iterationName = survey.iteration_name?.toLowerCase() || '';
          const surveyName = survey.survey_template_name?.toLowerCase() || '';
          
          if (!fullName.includes(query) && 
              !programName.includes(query) && 
              !iterationName.includes(query) &&
              !surveyName.includes(query)) {
            return false;
          }
        }

        return true;
      });
    },

    paginatedFilteredSurveys() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredSurveys.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredSurveys.length / this.itemsPerPage);
    },

    displayedPages() {
      const pages = [];
      const maxVisible = 5;
      
      if (this.totalPages <= maxVisible) {
        for (let i = 1; i <= this.totalPages; i++) {
          pages.push(i);
        }
      } else {
        if (this.currentPage <= 3) {
          for (let i = 1; i <= 4; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(this.totalPages);
        } else if (this.currentPage >= this.totalPages - 2) {
          pages.push(1);
          pages.push('...');
          for (let i = this.totalPages - 3; i <= this.totalPages; i++) {
            pages.push(i);
          }
        } else {
          pages.push(1);
          pages.push('...');
          pages.push(this.currentPage - 1);
          pages.push(this.currentPage);
          pages.push(this.currentPage + 1);
          pages.push('...');
          pages.push(this.totalPages);
        }
      }
      
      return pages;
    },

    showTakeSurvey() {
      return this.surveyAssignments.some(data => 
        data.is_nomination == 0 &&
        data.submitted_status == 0 &&
        data.dropped_status == 0
      );
    }
  },
  watch: {
    // Reset to page 1 when filters change
    activeFilters: {
      handler() {
        this.currentPage = 1;
      },
      deep: true
    },
    // Reset to page 1 when toggling archived view
    showArchived() {
      this.currentPage = 1;
    }
  },
  async mounted() {
    // Set surveyId - if userId is defined (from admin), use it; otherwise use userData.ind_id
    if (this.userId) {
      this.surveyId = this.userId;
    } else {
      this.surveyId = this.userData.ind_id;
    }

    try {
      // Get survey assignments with messages already included
      const res = await api.get(`survey-assignments/individuals/${this.surveyId}`, {  
        signal: this.abortController.signal,  
      });

      this.surveyAssignments = res.data;

      if (this.surveyAssignments.length <= 0) {
        this.noSurvey = true;
        this.isLoading = false;
        return;
      }

      // Process each survey assignment
      this.surveyAssignments.forEach((list) => {
        // Build the survey template link using website_url from API response
        list.survey_template_link = list.survey_file;
        
        // Set display names from the data already in the response
        list.surveyName = list.survey_template_name;
        list.programName = list.program_name;
        list.iterationName = list.iteration_name;
        list.subjectFullName = list.subject_full_name;
        
        // Ensure surveyMessages array exists (it should from API)
        if (!list.surveyMessages) {
          list.surveyMessages = [];
        }
        
        // Ensure archived_status exists (default to false if not in API)
        if (list.archived_status === undefined) {
          list.archived_status = false;
        }
      });

      this.isLoading = false;

    } catch (e) {
      this.isLoading = false;
      if(e.message == 'canceled') {
        return;
      } else {
        flashMessage(
          this.$flashMessage,
          this.brandData.accent_color1 ? this.brandData.accent_color1 : "#F47820",
          this.brandData.flash_text_color ? this.brandData.flash_text_color : "#ffffff",
          e.message
        );
      }
    }
  },
  methods: {
    async toggleArchive(surveyAssignmentId) {
      const survey = this.surveyAssignments.find(
        s => s.survey_assignment_id === surveyAssignmentId
      );

      if (!survey) return;

      console.log('[toggleArchive] START - id:', surveyAssignmentId);
      this.isArchivingModal = true;
      this.archiveSuccess = false;

      try {
        const newStatus = survey.archived_status ? 0 : 1;
        console.log('[toggleArchive] calling API - newStatus:', newStatus);

        await api.put(`survey-assignments/${surveyAssignmentId}/archive`, {
          archived_status: newStatus,
          modified_by: this.surveyId
        });

        console.log('[toggleArchive] API done - mutating survey.archived_status');
        survey.archived_status = newStatus;
        console.log('[toggleArchive] setting isArchivingModal false, archiveSuccess true');
        this.isArchivingModal = false;
        this.archiveSuccess = true;
        console.log('[toggleArchive] DONE');

      } catch (error) {
        console.error('Error toggling archive:', error);
        this.isArchivingModal = false;
        this.archiveSuccess = false;
        this.showArchiveConfirm = false;
        this.confirmArchiveId = null;
        this.confirmArchiveStatus = false;
        flashMessage(
          this.$flashMessage,
          "#ff0000",
          "#ffffff",
          "Failed to update archive status"
        );
      }
    },

    toggleShowArchived() {
      this.showArchived = !this.showArchived;
    },

    openArchiveConfirmation(surveyAssignmentId, currentStatus) {
      this.confirmArchiveId = surveyAssignmentId;
      this.confirmArchiveStatus = currentStatus;
      this.showArchiveConfirm = true;
    },

    closeArchiveConfirmation() {
      this.showArchiveConfirm = false;
      this.confirmArchiveId = null;
      this.confirmArchiveStatus = false;
      this.isArchivingModal = false;
      this.archiveSuccess = false;
    },

    async confirmArchiveAction() {
      if (this.confirmArchiveId) {
        await this.toggleArchive(this.confirmArchiveId);
      }
      // archiveSuccess is now true — user clicks anywhere or waits, nothing auto-closes
    },

    getMessageCount(messages, type) {
      return messages.filter(msg => msg.survey_message_type === type).length;
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        // Scroll to top of survey tiles
        const parentDiv = this.$el.querySelector('.parent');
        if (parentDiv) {
          parentDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    },
    openMessageModal(messages) {
      // Define sort order: Warning first, Info second, Qualified last
      const sortOrder = { 'Warning': 1, 'Info': 2, 'Qualified': 3 };
      
      this.currentMessages = messages
        .filter(msg => msg.survey_message_type && msg.survey_message_type != '')
        .sort((a, b) => {
          const orderA = sortOrder[a.survey_message_type] || 999;
          const orderB = sortOrder[b.survey_message_type] || 999;
          return orderA - orderB;
        });
      
      this.showMessageModal = true;
    },
    closeMessageModal() {
      this.showMessageModal = false;
      this.currentMessages = [];
    },
    toggleDisplaySubmittedSurvey() {
      this.isDisplaySubmittedSurvey = true;
    },
    getStyle(data) {
      if (data == "Warning") {
        return "rgb(255, 244, 229)";
      } else if (data == "Qualified") {
        return "rgb(237, 247, 237)";
      } else if (data == "Info") {
        return "rgb(232, 244, 253)";
      }
    },
    sendProps(
      surveyName,
      surveyAssignmentID,
      orgID,
      suborgID,
      programID,
      iterationID,
      streamID,
      groupID,
      surveyTemplateID,
      surveyTemplateAssociationID,
      indID,
      recipientEmail
    ) {
      const data = {
        surveyName: surveyName,
        surveyAssignmentID: surveyAssignmentID,
        orgID: orgID,
        suborgID: suborgID,
        programID: programID,
        iterationID: iterationID,
        streamID: streamID,
        groupID: groupID,
        surveyTemplateID: surveyTemplateID,
        surveyTemplateAssociationID: surveyTemplateAssociationID,
        indID: indID,
        recipientEmail: recipientEmail,
      };
      this.$router.push({
        name: "make_nominations",
        params: { data: JSON.stringify(data) },
      });
    },
    takeSurvey(
      survey_template_link,
      survey_assignment_id,
      ind_id,
      org_id,
      suborg_id,
      subjectFullName,
      survey_template_id,
      iteration_id
    ) {
      const data = {
        surveyTemplateLink: survey_template_link,
        surveyAssignmentLink: survey_assignment_id,
        indId: ind_id,
        orgId: org_id,
        suborgId: suborg_id,
        subjectFullName: subjectFullName,
        surveyTemplateId: survey_template_id,
        iteartionId: iteration_id,
        runMode: this.runMode
      };
      this.$router.push({
        name: "MySurvey",
        params: { data: JSON.stringify(data) },
      });
      this.$emit(
        "passSubjectFullName",
        subjectFullName ? subjectFullName : "none"
      );
    },
    adminSurveyView(
      survey_template_link,
      survey_assignment_id,
      ind_id,
      org_id,
      suborg_id,
      subjectFullName,
      survey_template_id,
      iteration_id
    ) 
    {
      if(this.isDisplaySubmittedSurvey === true) {
          const data = {
          surveyTemplateLink: survey_template_link,
          surveyAssignmentLink: survey_assignment_id,
          indId: ind_id,
          orgId: org_id,
          suborgId: suborg_id,
          subjectFullName: subjectFullName,
          surveyTemplateId: survey_template_id,
          iteartionId: iteration_id,
          runMode: "ReadOnly"
        };
        this.$router.push({
          name: "MySurveyAdmin",
          params: { data: JSON.stringify(data) },
        });
        this.$emit(
          "passSubjectFullName",
          subjectFullName ? subjectFullName : "none"
        );
      } else {
          const data = {
          surveyTemplateLink: survey_template_link,
          surveyAssignmentLink: survey_assignment_id,
          indId: ind_id,
          orgId: org_id,
          suborgId: suborg_id,
          subjectFullName: subjectFullName,
          surveyTemplateId: survey_template_id,
          iteartionId: iteration_id,
          runMode: this.runMode
        };
        this.$router.push({
          name: "MySurveyAdmin",
          params: { data: JSON.stringify(data) },
        });
        this.$emit(
          "passSubjectFullName",
          subjectFullName ? subjectFullName : "none"
        );
      }
      this.isDisplaySubmittedSurvey = false
    },
  },
  beforeUnmount() {
    this.abortController.abort();  
  }, 
};
</script>

<style scoped>
/* ===== TEMP: demo tile styling for client comparison — remove after approval ===== */
.demo-tile {
  position: relative;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  padding: 20px 18px;
  min-width: 250px;
  max-width: 250px;
  min-height: 380px;
  margin: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: box-shadow 0.2s ease, border-color 0.2s ease, transform 0.15s ease;
  font-family: 'Inter', sans-serif;
}
.demo-tile:hover {
  box-shadow: 0px 4px 20px rgba(18, 63, 117, 0.08);
  border-color: #123f75;
  transform: translateY(-2px);
}
.demo-archive {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 26px;
  height: 26px;
  border-radius: 4px;
  background: #eff4ff;
  border: 1px solid #c3c6d1;
  color: #434750;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}
.demo-eyebrow {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #36618b;
  text-align: center;
  margin-bottom: 8px;
}
.demo-badge {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
}
.demo-badge--vfp { background: linear-gradient(135deg, #7b3fa0, #d9a441); }
.demo-badge--360 { background: linear-gradient(135deg, #123f75, #36618b); }
.demo-badge--bep { background: linear-gradient(135deg, #1e7d3a, #36618b); }
.demo-title {
  font-size: 15px;
  font-weight: 600;
  color: #0b1c30;
  text-align: center;
  line-height: 1.35;
  margin: 0 0 6px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 40px;
}
.demo-sub {
  font-size: 12px;
  color: #434750;
  text-align: center;
  margin: 0 0 16px;
}
.demo-icons {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 16px;
}
.demo-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
}
.demo-icon--check { background: #dcf5e3; color: #1e7d3a; }
.demo-icon--info { background: #a6d0ff; color: #36618b; }
.demo-icon--warning { background: #fff0d6; color: #a15c00; }
.demo-actions {
  display: flex;
  gap: 8px;
  width: 100%;
  margin-top: auto;
}
.demo-btn {
  flex: 1;
  border: none;
  border-radius: 0.25rem;
  padding: 11px 10px;
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
}
.demo-btn--primary { background: #002955; color: #ffffff; }
.demo-btn--secondary { background: #dce9ff; color: #0b1c30; }
.main-div {
  min-width: 75vw;
  margin: 0;
  font-family: var(--font-family, 'Inter', sans-serif);
}
.bg-main-color1 {
  border-radius: var(--radius-lg, 0.5rem) var(--radius-lg, 0.5rem) 0 0;
  font-size: var(--label-md-size, 12px);
  letter-spacing: var(--label-md-tracking, 0.05em);
  text-transform: uppercase;
}
.parent {
  display: flex;
  flex-wrap: wrap;
  padding: var(--space-sm, 16px);
  min-height: 200px;
  background: var(--card-bg, #ffffff);
  border: 1px solid var(--card-border, #e2e8f0);
  border-top: none;
  border-radius: 0 0 var(--radius-lg, 0.5rem) var(--radius-lg, 0.5rem);
}
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 40px;
}
.spinner {
  border: 4px solid var(--surface-container-low, #eff4ff);
  border-top: 4px solid var(--primary, #002955);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.loading-text {
  margin-top: 20px;
  font-size: var(--body-md-size, 14px);
  color: var(--on-surface-variant, #434750);
  font-weight: 500;
}
.child,
.child-submitted,
.child-nominee {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;
  background: var(--card-bg, #ffffff);
  border: 1px solid var(--card-border, #e2e8f0);
  border-radius: var(--radius-lg, 0.5rem);
  text-align: center;
  min-width: 250px;
  max-width: 250px;
  min-height: 380px;
  margin: var(--space-xs, 8px);
  padding: var(--space-sm, 16px);
  box-shadow: none;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}
.child-nominee {
  background-color: var(--surface-container-low, #eff4ff);
}
.child:hover,
.child-submitted:hover,
.child-nominee:hover {
  box-shadow: var(--shadow-hover, 0px 4px 20px rgba(18, 63, 117, 0.05));
  border-color: var(--primary-container, #123f75);
  transition: all 200ms ease;
}
.message-icons-container {
  margin: var(--space-xs, 8px) 0 0 0;
  padding: 4px;
}
.message-icons {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}
.message-icon {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 15px;
  position: relative;
}
.message-icon:hover {
  transform: scale(1.15);
}
.icon-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  color: white;
  padding: 0 5px;
  border: 2px solid white;
}
.badge-qualified { background-color: #1e7d3a; }
.badge-info { background-color: var(--secondary, #36618b); }
.badge-warning { background-color: #a15c00; }
.icon-qualified {
  color: #1e7d3a;
  background-color: #dcf5e3;
  padding: 10px;
  border-radius: 50%;
}
.icon-info {
  color: var(--secondary, #36618b);
  background-color: var(--secondary-container, #a6d0ff);
  padding: 10px;
  border-radius: 50%;
}
.icon-warning {
  color: #a15c00;
  background-color: #fff0d6;
  padding: 10px;
  border-radius: 50%;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(11, 28, 48, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.modal-content {
  background-color: var(--card-bg, #ffffff);
  border-radius: var(--radius-lg, 0.5rem);
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 30px rgba(11, 28, 48, 0.2);
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--space-sm, 16px) var(--space-md, 24px);
  border-bottom: 1px solid var(--row-divider, #f1f5f9);
  background-color: var(--surface-container-low, #eff4ff);
}
.modal-header h3 {
  margin: 0;
  font-size: var(--headline-md-size, 18px);
  font-weight: var(--headline-md-weight, 600);
  color: var(--on-surface, #0b1c30);
}
.modal-close {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: var(--outline, #737781);
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}
.modal-close:hover {
  color: var(--on-surface, #0b1c30);
}
.modal-body {
  padding: var(--space-md, 24px);
  overflow-y: auto;
}
.modal-message-item {
  padding: var(--space-sm, 16px);
  margin-bottom: 12px;
  border-radius: var(--radius-md, 0.375rem);
  box-shadow: none;
  border: 1px solid var(--row-divider, #f1f5f9);
}
.modal-message-item:last-child {
  margin-bottom: 0;
}
.survey-message-container {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.message-icon-large {
  font-size: 20px;
  min-width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.message-text {
  flex: 1;
  font-size: var(--body-md-size, 14px);
  line-height: var(--body-lg-line, 1.6);
  color: var(--on-surface, #0b1c30);
}
.btn { width: 100%; }
.d-flex { display: flex; }

.btn-nominee {
  background-color: var(--primary, #002955);
  color: var(--on-primary, #ffffff);
  border-radius: var(--radius, 0.25rem);
  cursor: pointer;
  font-size: var(--body-md-size, 14px);
  border: none;
  font-weight: 500;
  margin-left: 5px;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: var(--space-xs, 8px);
  font-family: var(--font-family, 'Inter', sans-serif);
  transition: opacity 0.2s ease;
}
.btn-disabled {
  background-color: var(--surface-container-high, #dce9ff);
  color: var(--on-surface-variant, #434750);
  border-radius: var(--radius, 0.25rem);
  font-size: var(--body-md-size, 14px);
  border: none;
  font-weight: 500;
  margin-left: 5px;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: var(--space-xs, 8px);
  font-family: var(--font-family, 'Inter', sans-serif);
}
.btn-nominee:hover {
  text-decoration: none;
  opacity: 0.88;
  transition-duration: 0.1s;
}
.px-25px { padding-left: 25px; padding-right: 25px; }
.btn-survey-completed { padding: 14px 55px; }
.btn-take-survey { padding: 14px 55px; }
.btn-survey-completed-nominee { padding: 7px 38px; }
.btn-survey-completed-participant-nominee { padding: 13px 38px; }
.btn-take-survey-participant-nominee { padding: 13px 57px; }

.surveyLogo {
  width: 150px;
  height: auto;
}
.tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;
  color: var(--outline, #737781);
}
.tooltip .tooltiptext {
  visibility: hidden;
  width: 150px;
  background-color: var(--inverse-surface, #213145);
  color: var(--inverse-on-surface, #eaf1ff);
  text-align: center;
  border-radius: var(--radius, 0.25rem);
  padding: 8px 6px;
  position: absolute;
  z-index: 1;
  font-size: 12px;
}
.tooltip:hover .tooltiptext { visibility: visible; }
.baseline { width: 60%; margin-top: 10px; }
.solo-nomination {
  width: 100% !important;
  padding-left: 25px;
  padding-right: 25px;
}

.pagination-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: var(--space-md, 24px);
  padding: var(--space-md, 24px) var(--space-xs, 8px);
  flex-wrap: wrap;
}
.pagination-btn {
  min-width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--outline-variant, #c3c6d1);
  background-color: var(--card-bg, #ffffff);
  color: var(--on-surface, #0b1c30);
  border-radius: var(--radius, 0.25rem);
  cursor: pointer;
  font-size: var(--body-md-size, 14px);
  font-weight: 500;
  transition: all 0.2s ease;
  padding: 0 12px;
  font-family: var(--font-family, 'Inter', sans-serif);
}
.pagination-btn:hover:not(:disabled):not(.active) {
  background-color: var(--primary, #002955);
  color: var(--on-primary, #ffffff);
  border-color: var(--primary, #002955);
}
.pagination-btn.active {
  background-color: var(--primary, #002955);
  color: var(--on-primary, #ffffff);
  border-color: var(--primary, #002955);
  font-weight: 600;
}
.pagination-btn:disabled {
  background-color: var(--surface-container-low, #eff4ff);
  color: var(--outline-variant, #c3c6d1);
  cursor: not-allowed;
  border-color: var(--row-divider, #f1f5f9);
}
.pagination-info {
  width: 100%;
  text-align: center;
  margin-top: 10px;
  font-size: 13px;
  color: var(--on-surface-variant, #434750);
  font-family: var(--font-family, 'Inter', sans-serif);
}

@media only screen and (min-width: 280px) and (max-width: 540px) {
  .main-div { margin: 0; }
  .modal-content { width: 95%; max-height: 90vh; }
}

.tile-top-section {
  flex: 0 0 auto;
  width: 100%;
  padding-top: 6px;
  position: relative;
}
.tile-bottom-section {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-top: auto;
}
.message-icons-container { margin: 5px 0 0 0; padding: 5px; }

/* Archive Toggle Button in Header */
.archive-toggle-btn {
  background-color: rgba(255, 255, 255, 0.15);
  color: var(--on-primary, #ffffff);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: var(--radius-full, 9999px);
  padding: 6px 15px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  font-weight: 500;
  font-family: var(--font-family, 'Inter', sans-serif);
  text-transform: none;
  letter-spacing: 0;
}
.archive-toggle-btn:hover {
  background-color: rgba(255, 255, 255, 0.25);
  border-color: rgba(255, 255, 255, 0.5);
}
.archive-toggle-btn i { font-size: 13px; }

.archive-icon-btn {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 26px;
  height: 26px;
  border-radius: 0 var(--radius-md, 0.375rem) 0 var(--radius, 0.25rem);
  background-color: var(--surface-container-low, #eff4ff);
  border: 1px solid var(--outline-variant, #c3c6d1);
  color: var(--on-surface-variant, #434750);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  transition: all 0.2s ease;
  z-index: 10;
  opacity: 0.7;
}
.archive-icon-btn:hover:not(:disabled) {
  opacity: 1;
  background-color: var(--surface-container, #e5eeff);
  border-color: var(--primary-container, #123f75);
  transform: scale(1.08);
}
.archive-icon-btn.archived {
  opacity: 1;
  background-color: var(--surface-container-high, #dce9ff);
  border-color: var(--outline, #737781);
  color: var(--on-surface, #0b1c30);
}
.archive-icon-btn.archived:hover:not(:disabled) {
  background-color: var(--surface-container-highest, #d3e4fe);
}
.archive-icon-btn:disabled { cursor: not-allowed; opacity: 0.4; }
.archive-icon-btn.archiving { opacity: 1; background-color: var(--surface-container, #e5eeff); }

.child.archived-tile,
.child-submitted.archived-tile,
.child-nominee.archived-tile {
  opacity: 0.65;
  border-color: var(--outline, #737781) !important;
  background-color: var(--surface-container-low, #eff4ff);
}
.child.archived-tile::before,
.child-submitted.archived-tile::before,
.child-nominee.archived-tile::before {
  content: '\1F4E6 ARCHIVED';
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--outline, #737781);
  color: white;
  padding: 3px 10px;
  border-radius: var(--radius-full, 9999px);
  font-size: 9px;
  font-weight: bold;
  z-index: 1;
  letter-spacing: 0.5px;
}
.child, .child-submitted, .child-nominee { position: relative; }
</style>